import { KeyMap } from "react-hotkeys";

import { STATS, SWITCH_TEAM, SUBMIT_DATA } from "../constants";

// @ts-ignore
export const statActionKeyMap: KeyMap = STATS.reduce((acc, current) => {
  // @ts-ignore
  acc[current.name] = {
    name: current.name,
    sequence: current.shortcutKey,
  };
  return acc;
}, {});

export const operationKeyMap: KeyMap = {
  //@ts-ignore
  [SWITCH_TEAM]: { name: SWITCH_TEAM, sequence: "i" },
  //@ts-ignore
  [SUBMIT_DATA]: { name: SUBMIT_DATA, sequence: "m" },
};
